
import React from "react";

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: React.ReactNode;
  description?: React.ReactNode;
  /** Rendert die Checkbox als umrandete Karte (Default: true). */
  showBorder?: boolean;
  containerClassName?: string;
}

/**
 * Design-System-Checkbox. Natives input[type=checkbox] mit Brand-accentColor,
 * token-/theme-aware. Native API (forwardRef + input-Props) → funktioniert
 * controlled (`checked`/`onChange`) UND mit react-hook-form `register`.
 */
export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { label, description, showBorder = true, containerClassName = "", className = "", disabled, ...props },
  ref
) {
  const content = (
    <div className={`flex gap-2 ${description ? "items-start" : "items-center"}`}>
      <input
        ref={ref}
        type="checkbox"
        disabled={disabled}
        className={`ds-control-accent h-4 w-4 rounded border-line-strong bg-surface ${description ? "mt-1" : ""} ${
          disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
        } ${className}`}
        {...props}
      />
      <div className={`flex-1 ${disabled ? "opacity-60" : ""}`}>
        <span className="text-sm font-medium text-content-2">{label}</span>
        {description && <p className="mt-1 text-xs text-content-3">{description}</p>}
      </div>
    </div>
  );

  return (
    <label
      htmlFor={props.id}
      className={
        showBorder
          ? `block rounded-lg border border-line-strong bg-surface px-4 ${
              description ? "pb-0 pt-3" : "py-2"
            } ${disabled ? "cursor-not-allowed" : "cursor-pointer"} ${containerClassName}`
          : `block ${disabled ? "cursor-not-allowed" : "cursor-pointer"} ${containerClassName}`
      }
    >
      {content}
    </label>
  );
});
